import { h } from "preact";
import { withWidgetConfiguration } from "../../../node_modules/@sgwt-widget/core";
import { BasicAgGrid, IHeader } from "../../common/components/AgGrid";
import { getTablePptExport } from "../../common/export/table-helper";
import { CheckReponseDataForError } from "../../common/generic/generic-helper";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { SalesCreditBvRetetionHelper } from "../../common/salescredit/salescredit-bv-retention-helper";
import { IProps } from "../../common/salescredit/salescredit-types";
import { mapData } from "../../common/utils/AirPnlRetentionRate/AirPnlHelper";
import { ISalesCreditRetentionEquivType } from "../../common/utils/AirPnlRetentionRate/AirPnlTypes";
import { fromStyleLocals } from "../../common/utils/css";
import { GetHeaders } from "../utils/helper";
// tslint:disable-next-line:no-var-requires
import * as style from "./SalesCreditBvEquiv.less";
const css = fromStyleLocals(style.locals);

interface IState {
  email: string;
  data: ISalesCreditRetentionEquivType;
  headers: IHeader[];
}

export class SalesCreditBvEquivClass extends SalesCreditBvRetetionHelper<
  IState
> {
  private child: any;

  public constructor() {
    super();
    this.setState({
      data: {
        BVEquiv: 0,
        RetentionEquiv: "",
        SalesCreditList: [],
      },
    });
  }

  public getPptExport() {
    const columnsWidth = [2, 3, 1, 1];
    return getTablePptExport(
      this.child._parentComponent.api.gridOptions.api.getDataAsCsv({
        suppressQuotes: true,
        columnSeparator: "¤",
      }),
      columnsWidth
    );
  }

  protected shouldFetchApiData(nextProps: IProps): boolean {
    return true;
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <div class={css("ag-grid-header")} style="display:block;height:95%;">
        <div style="Row">
          <div>
            <b>BV adjust: </b>
            {this.state.data.BVEquiv.toLocaleString("en") + " K€"}
          </div>
          <div>
            <b>Retention adjust: </b>
            {this.state.data.RetentionEquiv}
          </div>
        </div>
        <BasicAgGrid
          ref={instance => {
            this.child = instance != null ? instance._component : instance;
          }}
          onChange={this.props.onChange}
          rowData={this.state.data.SalesCreditList}
          columnDefs={this.state.headers}
          fileName={"Retention_rate"}
          showExcelToExport={true}
          showFilterBox={false}
          userSelection={this.props.userSelection}
        />
        <style>{style.toString()}</style>
      </div>
    );
  }

  protected ProcessData(responseData: IGenericAggregateResponse) {
    const errorStatusForSC = CheckReponseDataForError(responseData);

    const error = errorStatusForSC;
    if (error) {
      this.setDataStatus(error === undefined ? "no-data" : error);
      this.setStatusText(responseData.statusText);
      this.setState({
        data: {
          BVEquiv: 0,
          RetentionEquiv: "",
          SalesCreditList: [],
        },
        headers: [],
      });
      return;
    }
    const result: ISalesCreditRetentionEquivType = mapData(responseData);
    if (result !== undefined && result.SalesCreditList !== undefined) {
      if (result.SalesCreditList.length !== 0) {
        this.setState({
          data: result,
          headers: GetHeaders(),
        });
        this.setDataStatus("ready");
      }
    } else {
      this.setState({
        data: {
          BVEquiv: 0,
          RetentionEquiv: "",
          SalesCreditList: [],
        },
        headers: [],
      });
      this.setDataStatus("no-data");
    }
  }
}
export const SalesCreditBvEquiv = withWidgetConfiguration(
  SalesCreditBvEquivClass
);
